import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue';
import native from '@/utils/native';


export default /*#__PURE__*/_defineComponent({
  __name: 'income-redirect',
  setup(__props) {

onMounted(() => {
  setTimeout(() => {
    console.log('wallet');
    native.method.walletConfirmDone();
  }, 500);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, "确认收款跳转中..."))
}
}

})